import React from 'react';
import { connect } from 'react-redux';
import { searchMessagesDatabase } from '../../actions/alert_actions';
import { bindActionCreators } from 'redux';
import { DatePicker } from '../inputs';
const Materialize = window.Materialize;

class SearchMessages extends React.Component {

componentDidUpdate() {
  let start = document.getElementById('dateStart').value;
  let end = document.getElementById('dateEnd').value;
  //allow query to be sent only if a start and end date have been specified
  if (start && end && !this.props.list[0]) {
    Materialize.toast('No messages were found.', 4000, 'rounded red');
  }
}

  renderList() {
    //render list of messages fetched by database
    return this.props.list.map((message,i) => {
      return (
        <tr key={i.toString()}>
          <td>{message.dateSent.substring(0,10)}</td>
          <td>{message.message}</td>
          <td>{message.location}</td>
        </tr>
      );
    });
  }

  searchForMessages() {
    //searcg for messages using start and end dates
    let start = document.getElementById('dateStart').value;
    let end = document.getElementById('dateEnd').value;
    if (start && end) {
      this.props.searchMessagesDatabase(start,end);
    } else {
      Materialize.toast('Select a beginning and last date for your search.', 4000 ,'rounded red')
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <br/>
        <div className="row">
          <div className="input-field col m5">
            <DatePicker id={'dateStart'} label={'Beginning Date'} min={'2018-07-19'} />
          </div>
          <div className="input-field col m5">
            <DatePicker id={'dateEnd'} label={'Last Date'} min={'2018-07-19'} />
          </div>
          <div className="input-field col m2">
            <button className="btn " onClick={() => {this.searchForMessages()}}>
              Search
              <i className="material-icons right">search</i>
            </button>
          </div>
        </div>
        <div className="messages-table">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Message</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {this.renderList()}
            </tbody>
          </table>
        </div>
      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    list: state.messages.searchedMessages
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchMessagesDatabase
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchMessages);



// WEBPACK FOOTER //
// ./src/components/alert/search-messages.js